import React, { useState } from 'react';
import { Button, Col, Row, Container } from "react-bootstrap";
import { Icon } from '@iconify/react';

// Styles
import './Especificacoes.scss';

/**
 * Normaliza itens para texto seguro no JSX.
 * Aceita string, number ou objeto { opcional | label | nome | descricao }.
 */
const toText = (v) => {
  if (v == null) return '';
  if (typeof v === 'string' || typeof v === 'number') return v;
  if (typeof v === 'object') {
    // tenta campos comuns
    return (
      v.opcional ??
      v.label ??
      v.nome ??
      v.descricao ??
      ''
    );
  }
  return '';
};

/**
 * Gera um array de strings seguro para render.
 */
const normalizeList = (arr) => {
  if (!Array.isArray(arr)) return [];
  return arr
    .map(toText)
    .map((s) => (typeof s === 'string' ? s.trim() : s))
    .filter((s) => s !== '');
};

const Especificacoes = ({
  opcionais = [],
  destaques = [],
  detalhesEspecificacoes = {}
}) => {
  // Normaliza antes de usar
  const normOpcionais = normalizeList(opcionais);
  const normDestaques = normalizeList(destaques);

  const temOpcionais = normOpcionais.length > 0;
  const temDestaques = normDestaques.length > 0;

  // Abas: se há opcionais e destaques, começa em opcionais; senão, mostra o que existir
  const [mostrarOpcionais, setMostrarOpcionais] = useState(temOpcionais || (!temOpcionais && !temDestaques));
  const [mostrarDestaques, setMostrarDestaques] = useState(!mostrarOpcionais && temDestaques);

  const toggleMostrarOpcionais = () => {
    if (!temOpcionais) return;
    setMostrarOpcionais(true);
    setMostrarDestaques(false);
  };

  const toggleMostrarDestaques = () => {
    if (!temDestaques) return;
    setMostrarOpcionais(false);
    setMostrarDestaques(true);
  };

  // Título e descrição seguros
  const titulo = toText(detalhesEspecificacoes.titulo);
  const descricao = toText(detalhesEspecificacoes.descricao);

  return (
    <>
      <section className='especificacoesVeiculo'>
        <Container>
          <Row className='justify-content-md-center'>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={temOpcionais || temDestaques ? 6 : 7}
              className='color'
            >
              <div className='boxColor'>
                {titulo && <h2>{titulo}</h2>}
                {descricao && <p>{descricao}</p>}
              </div>
            </Col>

            {(temOpcionais || temDestaques) && (
              <Col xs={12} sm={12} md={12} lg={6} className='white'>
                <div className='boxWhite'>
                  {temOpcionais && (
                    <Button
                      className={mostrarOpcionais ? 'active' : ''}
                      onClick={toggleMostrarOpcionais}
                    >
                      Opcionais <i><Icon className="icons" icon="iconoir:arrow-down" /></i>
                    </Button>
                  )}

                  {temDestaques && (
                    <Button
                      className={mostrarDestaques ? 'active' : ''}
                      onClick={toggleMostrarDestaques}
                    >
                      Destaques <i><Icon className="icons" icon="iconoir:arrow-down" /></i>
                    </Button>
                  )}

                  {mostrarOpcionais && temOpcionais && (
                    <ul>
                      {normOpcionais.map((txt, index) => (
                        <li key={`op-${index}`}><span>{txt}</span></li>
                      ))}
                    </ul>
                  )}

                  {mostrarDestaques && temDestaques && (
                    <ul>
                      {normDestaques.map((txt, index) => (
                        <li key={`dest-${index}`}><span>{txt}</span></li>
                      ))}
                    </ul>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Especificacoes;
